/* eslint-disable */
import type { Money } from "../common/currency.pb";

export interface RecurringSchedule {
  frequency?: RecurringScheduleFrequency;
  /**
   * Use 1 - 7 for Monday - Sunday if Frequency is EVERY_WEEK or EVERY_TWO_WEEKS:
   * Use 1 - 31 if Frequency is EVERY_MONTH.
   * If the month does not have that date, the last day of the month will be used.
   */
  days_of_period?: number[];
  timezone?: string;
  /** Time offset in milliseconds in local timezone. */
  time_of_day?: number;
}

export enum RecurringScheduleFrequency {
  EVERY_WEEK = "EVERY_WEEK",
  EVERY_TWO_WEEKS = "EVERY_TWO_WEEKS",
  EVERY_MONTH = "EVERY_MONTH",
  EVERY_DAY = "EVERY_DAY",
}

export interface ScheduledTransactionPreference {
  enabled?: boolean;
  amount?: Money;
  recurring_schedule?: RecurringSchedule;
  type?: ScheduledTransactionPreferenceType;
  next_reload_at?: number;
  investment_entity_token?: string;
}

export enum ScheduledTransactionPreferenceType {
  CASH_IN = "CASH_IN",
  BTC_BUY = "BTC_BUY",
  EQUITY_BUY = "EQUITY_BUY",
}

export interface MergeCustomers {
  source_customer_token?: string;
  target_customer_token?: string;
}
